import { Text } from '@components/primitives/Text'
import {
  isArrivoBioMdd,
  isOtsukaMdd,
} from '@modules/trials/helpers/isHardcodedTrial'
import type { ParsedTimelineAttribute } from './getTimelineValues'

export const HeaderTimeline = ({
  nctId,
  reporting,
  screening,
  treatment,
}: {
  nctId: string
  reporting: ParsedTimelineAttribute
  screening: ParsedTimelineAttribute
  treatment: ParsedTimelineAttribute
}) => {
  // Sponsor request
  const customTreatmentTitle =
    isOtsukaMdd(nctId) || isArrivoBioMdd(nctId)
      ? 'Study Treatment'
      : 'Treatment'

  return (
    <div className='flex flex-col gap-2'>
      <div className='flex justify-between gap-4 rounded-md bg-blue500 p-3'>
        <Text className='text-white' styleName='p-xtiny' value={`Screening `} />
        <Text
          className='line-clamp-1 text-white'
          styleName='p-xtiny'
          value={screening.duration}
        />
      </div>
      <div className='flex justify-between gap-4 rounded-md bg-gradient-to-b from-blue500 to-[#916EDA] p-3'>
        <Text
          className='text-white'
          styleName='p-xtiny'
          value={`${customTreatmentTitle} `}
        />
        <Text
          className='line-clamp-1 text-white'
          styleName='p-xtiny'
          value={treatment.duration}
        />
      </div>
      <div className='flex justify-between gap-4 rounded-md bg-gradient-to-b from-[#916EDA] to-[#AC63C4] p-3'>
        <Text className='text-white' styleName='p-xtiny' value={`Follow Up `} />
        <Text
          className='line-clamp-1 text-white'
          styleName='p-xtiny'
          value={reporting.duration}
        />
      </div>
    </div>
  )
}
